export function is3dsPaymentMethod(paymentMethod) {
    return paymentMethod === 'chcybersource';
}
